import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-oil-gas',
  templateUrl: './oil-gas.component.html',
  styleUrls: ['./oil-gas.component.scss']
})
export class OilGasComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }
  iniciarChatWhatsapp(){
	window.open('https://api.whatsapp.com/send?phone=573176488875&text=')
  }

}
